export default "__VITE_ASSET__76edb497__"